import { DirectionalHint, TeachingBubble } from '@fluentui/react';
import { Component } from 'react';
import * as React from 'react';
export class NavTeachingBubbleBase extends Component {
    render() {
        const { calloutProps, ...teachingBubbleProps } = this.props;
        return (React.createElement(TeachingBubble, { hasCondensedHeadline: true, hasSmallHeadline: true, hasCloseIcon: true, isWide: false, ...teachingBubbleProps, calloutProps: {
                beakWidth: 12,
                directionalHint: DirectionalHint.bottomLeftEdge,
                directionalHintFixed: true,
                ...calloutProps,
            } }));
    }
}
//# sourceMappingURL=nav-teaching-bubble.base.js.map